import React from 'react';
import './NotificationModal.css';
import { FormattedMessage } from 'react-intl';

const NotificationModal = ({ icon,id='notificationModal', message, className = '', description="", primaryButtonText="", secondaryButtonText = "CANCEL", showSecondaryButton = false, onClose, onSubmit }) => {
    return (
        <div className="notificationModal modal fade" id={id} tabIndex="-1" aria-labelledby={`${id}Label`} aria-hidden="true" data-bs-backdrop="static">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <img src={icon} alt="Notification" className="notification-image mb-3" />
                        <p className={"notification-message mb-2 " + className}><FormattedMessage id={message} /></p>
                        <p className="notification-description mt-3">{description && <FormattedMessage id={description} />}</p>
                        <div className="d-flex justify-content-center gap-2 mt-4">
                            {showSecondaryButton && (
                                <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}>
                                    <FormattedMessage id={secondaryButtonText} />
                                </button>
                            )}
                            <button className="btn btn-primary but-darkblue" onClick={onSubmit}>
                                <FormattedMessage id={primaryButtonText} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationModal;
